export function spotifyUriToId(uri: string) {
    return uri.substr(uri.lastIndexOf(':') + 1);
}
